<script>
import 'bulma/css/bulma.css'
import linkPrevue from 'link-prevue'

export default {
  components: {
    linkPrevue
  },
  props: ['url'],
  data () {
    return {
      newImage: [],
      innerWidth: window.innerWidth,
      object: undefined,
      imgFlag: false
    }
  },
  mounted: function () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    newImage: {
      handler: function (val) {
        this.getImageStyle()
      },
      deep: true
    }
  },
  methods: {
    handleResize: function () {
      this.innerWidth = window.innerWidth
      this.getImageStyle()
    },
    getImageSize (obj) {
      if (!this.object) {
        this.object = obj
        let img = new Image()
        img.onload = () => {
          this.newImage.push({width: img.width, height: img.height})
        }
        img.src = obj
        return obj
      }
    },
    getImageStyle () {
      let styleObj = {
        width: ''
      }
      if (this.newImage.length > 0) {
        let value = Math.ceil(1.3 * this.newImage[0].height / this.newImage[0].width)
        let imgWidth = 100 / value
        styleObj.width = imgWidth + '%'
        this.imgFlag = true
        return styleObj
      } else {
        styleObj.width = '0%'
        this.imgFlag = false
        return styleObj
      }
    }
  }
}
</script>
<style scoped>
.link {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  padding-top: 0px;
}
.card-title {
  margin-bottom: 0px !important;
}
.loader-container {
  width: 0px;
}
.card {
  border-radius: 5px;
  border-color: #A9A9A9;
  padding: 0px;
  box-shadow: 0 0 0 0px rgba(10,10,10,.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
  background-color: #fcfcfc;
}
.card-img-top {
  border-radius: 5px;
}
</style>
<template>
  <link-prevue :url="url">
    <template slot-scope="props">
      <div class="link">
        <div class="card" :id="getImageSize(props.img)" :style="getImageStyle()" >
          <div class="card-block">
          </div>
          <img class="card-img-top" :src="props.img" :alt="props.title" v-if="imgFlag">
        </div>
      </div>
    </template>
    <template slot="loading">
      <div class="loader-container"></div>
      <!-- set your custom loading -->
    </template>
  </link-prevue>
</template>



// WEBPACK FOOTER //
// src/components/LinkQuestionCard.vue